module.exports = __webpack_public_path__ + "files/d94eef7354d9d9059a1947120f18e5f9.png";